import { EyeOff, RotateCcw } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * Small round hide/unhide affordance on suggestion cards (NEA-5765). Mirrors the
 * fresh-dashboard design, including its Radix tooltip. Wraps its own
 * TooltipProvider since the app mounts no global one.
 */
export function HideButton({ onClick, mode = 'hide' }) {
	const isHide = mode === 'hide';
	const Icon = isHide ? EyeOff : RotateCcw;
	return (
		<TooltipProvider delayDuration={150}>
			<Tooltip>
				<TooltipTrigger asChild>
					<button
						type="button"
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							onClick();
						}}
						aria-label={isHide ? 'Hide suggestion' : 'Unhide suggestion'}
						className="-mr-2 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-border bg-white text-muted-foreground transition hover:bg-accent hover:text-foreground"
					>
						<Icon className="h-4 w-4" />
					</button>
				</TooltipTrigger>
				<TooltipContent>{isHide ? 'Hide suggestion if not relevant' : 'Unhide suggestion'}</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
}
